import React, { ChangeEvent, useState } from 'react';
import classNames from 'classnames';
import searchIcon from '@uswds/uswds/dist/img/usa-icons-bg/search--white.svg';
import Button from '../Button';
import Label from '../FormControls/Label';
import Input from '../FormControls/Input';

export interface SearchProps {
  className?: string;
  id: string;
  size?: 'small' | 'big';
  value?: string;
  placeholder?: string;
  onInputChange?: (value: string) => void;
  onSubmit: (value: string) => void;
}

const Search = ({ className, id, size, value, placeholder, onInputChange, onSubmit }: SearchProps): JSX.Element => {
  const [searchValue, setSearchValue] = useState(value || '');

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const newValue = e.target.value;

    if (onInputChange) {
      onInputChange(newValue);
    } else {
      setSearchValue(newValue);
    }
  };

  const onSubmitHandler = (e: React.FormEvent): void => {
    e.preventDefault();
    onSubmit(value || searchValue);
  };

  const searchClasses = classNames(
    'usa-search',
    {
      'usa-search--small': size === 'small',
      'usa-search--big': size === 'big',
    },
    className,
  );
  return (
    <form className={searchClasses} role="search" onSubmit={onSubmitHandler}>
      <Label className="usa-sr-only" htmlFor={id}>
        Search
      </Label>
      <Input id={id} type="search" value={value || searchValue} onChange={onChange} placeholder={placeholder} />
      <Button type="submit">
        {size !== 'small' && <span className="usa-search__submit-text">Search</span>}
        <img src={searchIcon} className="usa-search__submit-icon" alt="Search" />
      </Button>
    </form>
  );
};

export default Search;
